import React, {Fragment, useRef} from "react";
import { isMobile } from "react-device-detect";
import {useTranslation} from "react-i18next";
import {Controller, Navigation, Pagination, Scrollbar} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react/swiper-react";

import {HOME_PLAYLIST} from "constant/playlist.display";
import PrintDate from "components/boards/common/PrintDate";
import PlaylistThumb from "components/boards/playlist/PlaylistThumb";
import {numberCommaString} from "helpers";


const PlaylistVodSwiper = ({ playlist, authority = {}, inflowPath, thumbHeight, moreButtonTop }) => {


    const { t } = useTranslation();
    const prefBtnRef = useRef(null);
    const nextBtnRef = useRef(null);
    //const ucc = post.ucc || {};

    const checkPlaylistUcc = playlist.playlistUcc.filter((data, key) => {
        if (data.bbsTitle.length <= 0) return false;
        if (key >= 10) return false;

        return data;
    });


    return (
        <>
            <Swiper
                slidesPerView={4}
                id={'vod-list play_list'}
                className="vod-list"
                modules={[Controller, Navigation, Scrollbar, Pagination]}
                wrapperTag="ul"
                initialSlide={0}
                navigation={{ // 네비게이션 적용, < >
                    prevEl: prefBtnRef.current,
                    nextEl: nextBtnRef.current
                }}
                pagination={{clickable: true, el: '.swiper-pagination', type: 'bullets'}}
                scrollbar={isMobile ? {draggable: true, el: '.swiper-pagination'} : {}}
                spaceBetween={16}
            >
                
                {
                    checkPlaylistUcc.map((data, key) => {


                        if (data.bbsTitle.length <= 0) return null;
                        if (key >= 10) return null;

                        const { playlistUcc, count:playlistCount, ...other } = playlist;
                        const { bbsTitle, ...playOther } = data;
                        const { count, ...title } = bbsTitle[0];
                        const playlistUser = {
                            playlist : {
                                ...other,
                                playlistUcc: playOther,
                                count : {
                                    ...count,
                                    playlist_cnt: playlistCount
                                },
                                bbsTitle : bbsTitle[0],

                            }
                        };

                        // 재생목록 관련 데이터
                        /*const { list_idx = 0, manager_id = "", manager_nick = "", no = 0,
                            reg_date = "0000-00-00 00:00:00", sort = 0, bbsTitle = [], vod_adder = "" } = data;
                        */
                        // 게시글 정보
                        const { auth_no = 101, bbs_no = 0, board_type = 105, comment_yn = 1,
                            profile_image = "", reg_date:title_reg_date = '', station_no = 0, title_name = '', title_no = 0, ucc = {}
                        } = bbsTitle[0];


                        return (
                            <SwiperSlide
                                tag={'li'}
                                key={key}
                            >
                                <Fragment>
                                    <PlaylistThumb
                                        playlist={playlistUser.playlist}
                                        inflowPath={inflowPath}
                                        height={thumbHeight}
                                        playlistPathType={HOME_PLAYLIST}
                                    />

                                    {/*/!* vod 정보 노출 *!/*/}
                                    {/*<PlaylistInfo playlistUser={{ "playlist" : playlist }} inflowPath={inflowPath} />}
                                    */}

                                    <div className="vod-info">
                                        <p className="title">
                                            <a href="" target="_blank">{title_name}</a>
                                        </p>
                                        <div className="info">
                                            <span className="views"><em></em>{numberCommaString((count.read_cnt))}</span>
                                            {title_reg_date && <PrintDate tag="span" attributes={{ className: "date" }} target={title_reg_date} />}
                                        </div>
                                    </div>

                                </Fragment>
                            </SwiperSlide>
                        );
                    })
                }


                <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </Swiper>

            <button type="button" ref={prefBtnRef} className={"play_list-prev"} tabIndex="0"
                    aria-label="Previous slide">
                <span>이전</span>
            </button>
            <button type="button" ref={nextBtnRef} className="play_list-next" tabIndex="10"
                    aria-label="Next slide">
                <span>다음</span>
            </button>
        </>
    )


};

export default PlaylistVodSwiper;
